import React from 'react';
import { Link, LinkProps } from 'react-router-dom';
import { useLocale } from '@/contexts/LocaleContext';

interface LocaleLinkProps extends Omit<LinkProps, 'to'> {
  to: string;
}

/**
 * A locale-aware Link that automatically prepends the current locale prefix.
 * Falls back to a regular Link if outside a LocaleProvider.
 */
const LocaleLink = React.forwardRef<HTMLAnchorElement, LocaleLinkProps>(
  ({ to, ...props }, ref) => {
    let localizedTo = to;

    try {
      const { getLocalizedPath } = useLocale();
      // Don't prefix external URLs, hash-only links, or already-prefixed paths
      if (to.startsWith('/') && !to.match(/^\/[a-z]{2}-[A-Z]{2}(\/|$)/)) {
        localizedTo = getLocalizedPath(to);
      }
    } catch {
      // Outside LocaleProvider, use path as-is
    }

    return <Link ref={ref} to={localizedTo} {...props} />;
  }
);

LocaleLink.displayName = 'LocaleLink';

export default LocaleLink;
